'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' });

var NavigateBefore = function NavigateBefore(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

NavigateBefore = (0, _pure2.default)(NavigateBefore);
NavigateBefore.muiName = 'SvgIcon';

exports.default = NavigateBefore;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/NavigateBefore.js
// module id = 587
// module chunks = 0